import React, { useEffect, useState } from "react";

export default function Hero({
  title = "Default Title",
  subtitle = "",
  backgroundImage,
  backgroundImages = [],
  variant = "inner",
  overlayOpacity = "bg-black/10",
  children,
  slideInterval = 5000,
}) {
  const isHome = variant === "home";
  const [current, setCurrent] = useState(0);

  // Auto slide effect
  useEffect(() => {
    if (!isHome || backgroundImages.length <= 1) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % backgroundImages.length);
    }, slideInterval);

    return () => clearInterval(interval);
  }, [isHome, backgroundImages, slideInterval]);

  const activeImage =
    backgroundImages.length > 0
      ? backgroundImages[current]
      : backgroundImage;

  return (
    <section
      className={`relative overflow-hidden transition-all duration-700 ${isHome
        ? "min-h-[60vh] min-[700px]:min-h-[80vh] md:min-h-[500px] lg:min-h-[450px]"
        : "min-h-[220px] md:min-h-[320px]"
        }`}
    >
      {/* Background Slider */}
      {isHome && backgroundImages.length > 0 && (
        <>
          {backgroundImages.map((img, index) => (
            <div
              key={index}
              className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000"
              style={{
                backgroundImage: `url(${img})`,
                opacity: index === current ? 1 : 0,
              }}
            />
          ))}
        </>
      )}

      {/* Fallback single image */}
      {!isHome && activeImage && (
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${activeImage})`,
          }}
        />
      )}

      {/* Overlay */}
      <div
        className={`absolute inset-0 ${isHome
          ? overlayOpacity
          : "bg-gradient-to-r from-black/50 via-black/30 to-black/50"
          }`}
      />

      {/* Content */}
      <div
        className={`relative z-10 max-w-screen-2xl mx-auto px-4 sm:px-6 ${isHome
            ? "min-h-[60vh] min-[700px]:min-h-[80vh] md:min-h-[500px] lg:min-h-[450px] flex items-center justify-center"
            : "min-h-[220px] md:min-h-[320px] flex items-center justify-center text-center"
          }`}
      >
        {isHome ? (
          <div className="w-full">


            <div className="hidden lg:block">
              <div className="rounded-3xl shadow-2xl">
                {children}
              </div>
            </div>

            {children && (
              <div className="block lg:hidden">
                {children}
              </div>
            )}
          </div>
        ) : (
          <div className="text-white max-w-4xl mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-4">
              {title}
            </h1>

            {subtitle && (
              <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto">
                {subtitle}
              </p>
            )}

            {children && <div className="mt-6">{children}</div>}
          </div>
        )}
      </div>
    </section>
  );
}